module.exports = __webpack_public_path__ + "img/pad.02e7ee86.svg";